import React from 'react';
import '../style/Footer.css';

function Footer() {
    return (
        <footer className="footer2">
            <div className="footer-content2">
                <img src="../img/ipt_logo.png" alt="IPT Logo" className="footer-image2" />
                <img src="../img/ftc_logo.png" alt="FTC Logo" className="footer-image2" />
                <img src="../img/Techn&Art_logo.png" alt="Techn&Art Logo" className="footer-image2" />
            </div>
        </footer>
    );
}

export default Footer;
